import { render } from "./DefaultValue.vue?vue&type=template&id=34e5fe28"
import script from "./DefaultValue.vue?vue&type=script&lang=ts"
export * from "./DefaultValue.vue?vue&type=script&lang=ts"
script.render = render

export default script